var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylInvestStrategy"}},[(_vm.isMobileScreen)?_c('ylInvestStrategyMobile',_vm._b({ref:"box-mobile",attrs:{"list":_vm.list}},'ylInvestStrategyMobile',_vm.$attrs,false)):_c('ylInvestStrategyPC',_vm._b({ref:"box-pc",attrs:{"list":_vm.list}},'ylInvestStrategyPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }